/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useState, useCallback, useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateTrendingNowV2Config } from 'state/thunks/trendingnowv2';
import { setTempTrendingNowConfig } from 'state/slices/trendingnowv2';
// material
import ConfigV2Controller from 'material/expandablesection/v2/configv2controller/configv2controller'
import ExpandableSection from 'material/expandablesection/expandablesection'
import { ReactComponent as BoardActivity } from 'assets/icons/board-activity.svg'
// content
import Placements from './placements/placements';
import AdDetails from './addetails/addetails';
// styles
import injectSheet from 'react-jss'
import styles from './adssection_styles'
import Visibility from './visibility/visibility';
import Space from 'material/space/space';
import Preview from './preview/preview';


/* ========== ~~~~~~~~~~ TRENDING NOW CONFIG V2: ADS SECTION ~~~~~~~~~~ ========== */
const AdsSection = injectSheet(styles)((props) => {
  
  const dispatch = useDispatch()
  const { adsConfig: savedAdsConfig, status, trendingNowId } = useSelector(state => state.trendingNowV2.trendingNowConfig)
  const { adsConfig: tempAdsConfig, generalConfig } = useSelector(state => state.trendingNowV2.tempTrendingNowConfig)

  const [adsConfig, setAdsConfig] = useState(savedAdsConfig)
  const [isUpdating, setIsUpdating] = useState(false)
  const [isOpened, setIsOpened] = useState(false)
  const [selectedPlacementVersion, selectPlacementVersion] = useState('desktop')

  const [isScollIntoView, setIsScrollIntoView] = useState(false)

  useEffect(() => {
    let currentLocation = window.location.href;
    const hasCommentAnchor = currentLocation.includes("?view=adsConfig");
    if(hasCommentAnchor && (status === 'fulfilled' || status === 'rejected')) setIsOpened(true)
  },[status])

  useEffect(() => {
    if(isOpened && !isScollIntoView) scrollToComment()
  }, [isOpened, isScollIntoView])

  const scrollToComment= () => {
    let currentLocation = window.location.href;
    const hasCommentAnchor = currentLocation.includes("?view=adsConfig");
    if (hasCommentAnchor) {
      // fixHeaderPosition()
      const anchorComment = document.getElementById('ads-config');
      if(anchorComment){
        // anchorComment.style.scrollMargin = '100px';
          setTimeout(() => {
            anchorComment.scrollIntoView({ behavior: "smooth",  block: 'center'  })
            setIsScrollIntoView(true)
          }, 700)
      }
    }
  }
  
  const handleToggle = () => setIsOpened(!isOpened)

  const handleSave = useCallback(async (e) => {
    e.stopPropagation()
    setIsUpdating(true)
    const adsConfigRequest = {adsConfig: {...tempAdsConfig}, section: 'ADS'}
    const response = await dispatch(updateTrendingNowV2Config({ trendingNowConfig: {...adsConfigRequest}, trendingNowId }))
    if(!response.error && !response.payload.error) setIsOpened(false)
    setIsUpdating(false)
  }, [tempAdsConfig, dispatch, trendingNowId])

  const handleCancel = useCallback(async () => {
    setIsOpened(false)
    setAdsConfig(savedAdsConfig)
    dispatch(setTempTrendingNowConfig({
      configName: 'adsConfig',
      data: savedAdsConfig
    }))
  }, [dispatch, savedAdsConfig])

  const isChanged = useMemo(() => {
    const isFieldsChanged = !(JSON.stringify(tempAdsConfig) === JSON.stringify(savedAdsConfig));
    return isFieldsChanged
  }, [tempAdsConfig, savedAdsConfig])


  const handleAdsConfigChange = useCallback((property, value) => {
    const version = selectedPlacementVersion === 'desktop' ? 'desktopConfig' : 'mobileConfig'
    setAdsConfig({
      ...adsConfig,
      [version]: {
        ...adsConfig[version],
        [property]: value,
      }
    })

    dispatch(setTempTrendingNowConfig({
      configName: 'adsConfig',
      data: {
        ...adsConfig,
        [version]: {
          ...adsConfig[version],
          [property]: value,
        }
      }
    }))
}, [adsConfig, dispatch, selectedPlacementVersion]);

  const controller = (
    <ConfigV2Controller
      isOpened={isOpened}
      handleToggle={handleToggle}
      handleCancel={handleCancel}
      handleSave={handleSave}
      isProcessing={isUpdating}
      disableSave={!isChanged}
      saveTitle={'Save Changes'}
      icon={<BoardActivity />}
      title='Ads'
    />
  );

  const selectedConfig = adsConfig[selectedPlacementVersion === 'desktop' ? 'desktopConfig' : 'mobileConfig']


  return (
    <ExpandableSection
      className={`expandablesectionv2 adssection ${props.classes.adssection}`}
      controller={controller}
      isOpened={isOpened}
      handleToggle={handleToggle}
      handleCancel={handleCancel}
      handleSave={handleSave}
      isProcessing={savedAdsConfig.isUpdating}
      disableSave={!isChanged}
    >
      <Space>
        <Space gap={48} direction={'column'}>
          <Visibility
            version={selectedPlacementVersion} 
            onChange={handleAdsConfigChange} 
            {...selectedConfig}  
          />
          <Placements 
            version={selectedPlacementVersion} 
            selectVersion={selectPlacementVersion} 
            loadMoreStyle={generalConfig.layoutConfig.loadMoreStyle || 'BUTTON'}
            enableSpotlight={generalConfig.layoutConfig.enableSpotlight || false}
            onChange={handleAdsConfigChange} 
            {...selectedConfig}  
          />
          <AdDetails {...selectedConfig} />
        </Space>
        <Preview 
          version={selectedPlacementVersion} 
          selectVersion={selectPlacementVersion} 
          loadMoreStyle={generalConfig.layoutConfig.loadMoreStyle || 'BUTTON'}
          enableSpotlight={generalConfig.layoutConfig.enableSpotlight || false}
          {...selectedConfig}  
        />
      </Space>
    </ExpandableSection>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default AdsSection